<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="/"></ion-back-button>
        </ion-buttons>
        <ion-title>Contacts</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
        <ion-toolbar>
            <ion-searchbar @ionChange="searchList" debounce="500"></ion-searchbar>
        </ion-toolbar>
        <ion-list>
            <ion-item v-for="item in list" :key="item.id" @click="$router.push({ name: 'contact-detail' ,params:{contact:makeHospitalContact(item)}})">
              <ion-avatar slot="start">
                  <img src="../assets/hosp_icon.png">
              </ion-avatar>
              <ion-label>
                  <h2>{{item.name}}</h2>
                  <h3>{{item.local}}</h3>
                  <p>{{item.district}}</p>
              </ion-label>
            </ion-item>
            <ion-item v-for="item in people" :key="item.id" @click="$router.push({ name: 'contact-detail' ,params:{contact:makePeopeContact(item)}})">
              <ion-avatar slot="start">
                  <img src="../assets/human_icon.png">
              </ion-avatar>
              <ion-label>
                  <h2>{{item.fullname}}</h2>
                  <h3>{{item.title}}</h3>
                  <p>{{item.district}}</p>
              </ion-label>
            </ion-item>
        </ion-list>
    </ion-content>
  </ion-page>
</template>

<script>
export default {
    name:'search-contacts',
    props:{
        search_type:{
            type:String,
            default:'people'
        }
    },
    data(){
        return {
            list:[],
            people:[]
        }
    },
    methods:{
        searchList(ev){
            if(ev.detail.value){
                if(this.search_type==='people'){
                    this.loadPeople(ev.detail.value);
                }else{
                    this.loadList(ev.detail.value);
                }
            }
        },
        loadList(search_term){
            const base_url=this.$store.get('base_url');
            this.$http.get(base_url+'/api/hospitals/search/all?query='+encodeURIComponent(search_term))
            .then((res)=>this.list=res.data)
            .catch((err)=>console.log(err));
        },
        loadPeople(search_term){
            const base_url=this.$store.get('base_url');
            this.$http.get(base_url+'/api/hospitals/search/people?query='+encodeURIComponent(search_term))
            .then((res)=>this.people=res.data)
            .catch((err)=>console.log(err));
        },
        makePeopeContact(pitem){
            return {
                fullname:pitem.fullname,
                title:pitem.title,
                phone:pitem.cellphone,
                email:pitem.email
            };
        },
        makeHospitalContact(hitem){
            return{
                fullname:hitem.name,
                title:hitem.local,
                phone:"("+hitem.tel_code+")"+" "+hitem.tel,
                email:''
            }
        }
    }
}
</script>

<style scoped>
ion-toolbar {
  --ion-toolbar-background:#fbc414;
  --ion-text-color:white;
}
ion-back-button{
    --color:white;
}
ion-button{
    --background:#1b9346;
}
</style>